import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class DataService {
  public data = [];
  public fileName = '';
  public tempalte = [];
  private messageSource = new BehaviorSubject<any>(this.data);
  private screenSource = new BehaviorSubject<any>(this.data);
  private openFileSource = new BehaviorSubject<any>(this.fileName);
  private templateSource = new BehaviorSubject<any>(this.tempalte);
  currentMessage = this.messageSource.asObservable();
  currentScreen = this.screenSource.asObservable();
  currentFile = this.openFileSource.asObservable();
  currentTemplate = this.templateSource.asObservable();

  constructor() { }

  changeMessage(message: any) {
    this.messageSource.next(message);
  }

  changeScreen(message: any) {
    this.screenSource.next(message);
  }

  openFile(fileName) {
    this.openFileSource.next(fileName);
  }

  changeTemplate(template){
    this.templateSource.next(template);
  }
}


// WEBPACK FOOTER //
// ./src/app/services/data.service.ts